export default "__VITE_ASSET__3ce72e8a__"